import { createAction } from '@reduxjs/toolkit';

export const saveValidateImport = createAction<number>('validateImport/saveData');
export const resetValidateImport = createAction('validateImport/resetData');
